import { USER_ROLES } from '../../../constants';

/**
 * Normalize backend/JWT role values to frontend display roles.
 * Accepts: USER | ADMIN | SUPER_ADMIN | User | Admin | Super Admin | { name: 'SUPER_ADMIN' }
 * @param {string|Object|null|undefined} rawRole
 * @returns {string} One of USER_ROLES values
 */
export const normalizeUserRole = (rawRole) => {
  if (!rawRole) {
    return USER_ROLES.USER;
  }

  const value = typeof rawRole === 'object' && rawRole !== null
    ? (rawRole.name || rawRole.role || '')
    : rawRole;

  const normalized = String(value).trim();
  if (!normalized) {
    return USER_ROLES.USER;
  }

  const key = normalized.toUpperCase().replace(/\s+/g, '_');
  if (key === 'SUPER_ADMIN' || normalized === USER_ROLES.SUPER_ADMIN) {
    return USER_ROLES.SUPER_ADMIN;
  }
  if (key === 'ADMIN' || normalized === USER_ROLES.ADMIN) {
    return USER_ROLES.ADMIN;
  }
  if (key === 'USER' || normalized === USER_ROLES.USER) {
    return USER_ROLES.USER;
  }

  return USER_ROLES.USER;
};

/**
 * Decode JWT payload without verification (client-side convenience only).
 * @param {string} token
 * @returns {Object|null}
 */
export const decodeJwtPayload = (token) => {
  if (!token || typeof token !== 'string') {
    return null;
  }
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};

/**
 * Extract primary role from JWT claims.roles array.
 * @param {string} token
 * @returns {string} Normalized frontend role
 */
export const getRoleFromToken = (token) => {
  const payload = decodeJwtPayload(token);
  const roles = payload?.roles;
  if (Array.isArray(roles) && roles.length > 0) {
    return normalizeUserRole(roles[0]);
  }
  if (typeof roles === 'string') {
    return normalizeUserRole(roles);
  }
  return USER_ROLES.USER;
};
